import React from 'react';

export const AssessmentHasReviewNeededYellowFlagging: React.FC = () => {
  return (
    <div className="modal-template assessment-review-needed">
      <h3>Assessment Review Needed</h3>
      <div className="alert-indicator yellow">
        ATTENTION NEEDED
      </div>
      <p>Multiple students have flagged responses in the reading assessment that require your review.</p>
      <p>These responses may indicate areas where additional instruction or support is needed.</p>
      <div className="student-list-placeholder">
        <ul>
          <li>Student 1</li>
          <li>Student 2</li>
        </ul>
      </div>
      <div className="action-buttons">
        <button className="btn btn-primary">Review Assessments</button>
        <button className="btn btn-secondary">Schedule Group Review</button>
      </div>
    </div>
  );
};

export default AssessmentHasReviewNeededYellowFlagging; 